"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tabs = (props) => {
    const { tabs, onTab, tabsContainerRef, activeLineStyle } = props;
    return (react_1.default.createElement("div", { className: 'tabs-row' },
        react_1.default.createElement("div", { ref: tabsContainerRef, id: 'tabs-container', className: 'tabs-container' }, tabs
            .map((tab) => tab)
            .map((value, index) => (react_1.default.createElement("p", { key: index, onClick: () => onTab(value.tabName), className: 'small bold' }, value.tabName)))),
        react_1.default.createElement("div", { className: 'active-line', style: activeLineStyle })));
};
exports.default = Tabs;
